import { Pipe, PipeTransform } from '@angular/core';
import { GlobalService } from '@common/global';

@Pipe({
  name: 'audio'
})
export class AudioPipe implements PipeTransform {
  audio_url = "";
  constructor(private _global: GlobalService) { }
  transform(value: any, args?: any): any {
    let v_urls = this._global.baseAudio;
    let obj = value;
    if (obj != undefined) {
      var fileFormat = '.mp3';
      var mediaId = this._global.getVal(obj, 'id', '');
      var metadata = this._global.getVal(obj, 'metadata', '');
      if (metadata != undefined) {
        var pathToMedia = this._global.getVal(metadata, 'pathToMedia', '');
        if (pathToMedia != undefined) {
          var mediaObj = pathToMedia[mediaId];
          if (mediaObj != undefined) {
            fileFormat = "."+ this._global.getVal(mediaObj, 'fileFormat', 'mp3');
          }
        }
      }
      if (args != undefined) {
        if (args[0] == "activity") {
          this.audio_url = "play/" + this._global.getVal(obj, 'mediaType', '') + "/" + this._global.getVal(obj, 'mediaId', '') + "/xl/" + this._global.getVal(obj, 'mediaName', 'noname') + "_" + this._global.getMilliseconds() + fileFormat;
        } else if (args[0] == "pathToMedia") {
          this.audio_url = "play/" + this._global.getVal(obj, 'mediaType', '') + "/" + this._global.getVal(obj, 'uid', '') + "/xl/" + this._global.getVal(obj, 'name', 'noname') + "_" + this._global.getMilliseconds()+ fileFormat;
        } else if (args[0] == "chat") {
          Object.entries(obj).forEach(([key, value]) => {
            if (value) {
              this.audio_url = "/play/attachment/" + this._global.getVal(value, 'uid', '') + "/xl/" + this._global.getVal(value, 'name', 'noname') + "_" + this._global.getMilliseconds() + fileFormat;
            }
          });
        }
      } else {
        this.audio_url = "play/" + this._global.getVal(obj, 'mediaType', '') + "/" + this._global.getVal(obj, 'id', '') + "/xl/" + this._global.getVal(obj, 'name', 'noname') + "_" + this._global.getMilliseconds() + fileFormat;
      }
    }
    return this.audio_url;
  }
}
